import { getDatabase, onValue, ref } from 'firebase/database'
import { memo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    setCentre,
    setCentreUser,
    setCentreDefault,
} from '../../../../redux/eccSlice'
import {
    selectUserUid
} from '../../../../redux/userSlice'

const CentreListeners = ({ centreId }: { centreId: string }) => {
    const dispatch = useDispatch()

    const userId = useSelector(selectUserUid)

    useEffect(() => {
        if (!userId) {
            return
        }
        const centreRef = ref(
            getDatabase(),
            `childcareCentreInformation/${centreId}`
        )
        const centreUnsub = onValue(centreRef, (snap) => {
            dispatch(setCentre(snap.val()))
        })

        const centreUserRef = ref(
            getDatabase(),
            `childcareCentreUsers/${centreId}/${userId}`
        )
        const centreUserUnsub = onValue(centreUserRef, (snap) => {
            dispatch(setCentreUser(snap.val()))
        })

        return () => {
            centreUnsub()
            centreUserUnsub()
            dispatch(setCentreDefault())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [centreId, userId])

    return null
}

export default memo(CentreListeners)
